/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_Edit_AllInputs */



/**
* | output |
* | --- |
* | "Publishing edit results for all tracks." |
*
* @param {Work_Order_Publish_Status_Edit_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_edit_all = /** @type {((inputs?: Work_Order_Publish_Status_Edit_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_Edit_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publication des résultats d’édition pour toutes les pistes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichungsergebnisse für alle Titel.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione dei risultati delle modifiche per tutte le tracce.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Публикация результатов редактирования для всех треков.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicación de resultados de edición para todas las pistas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布所有曲目的编辑结果。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのトラックの編集結果を公開します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी ट्रैक के लिए संपादन परिणाम प्रकाशित किए जा रहे हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicando os resultados da edição para todas as faixas.")
	return /** @type {LocalizedString} */ ("Publishing edit results for all tracks.")
});